import { usePersonOptOut } from '../../history-list-container/patient-details-container/patient-info/person-opt-out.hook';
import { useWritebacks } from '../../settings/auto-message-debugger/appointment-debugger/writebacks.hook';

export const ResourceHooks = {
  [`/support/v1/phones/sms/optout/:personID`]: usePersonOptOut,
  [`/support/v1/writebacks`]: useWritebacks,
};
